import { render, staticRenderFns } from "./QuickAddBox.vue?vue&type=template&id=3888f86a&"
import script from "./QuickAddBox.vue?vue&type=script&lang=js&"
export * from "./QuickAddBox.vue?vue&type=script&lang=js&"
import style0 from "./QuickAddBox.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports